import { Component, EventEmitter, Input, Output } from '@angular/core';
import { StoreProduct } from 'src/app/model/store';
import { LOW_STOCK_THRESHOLD, PRODUCT_PLACEHOLDER } from '../../store.constants';

/** Card de produto da Loja: estados de estoque, saldo e quantidade no carrinho. */
@Component({
  selector: 'app-store-product-card',
  templateUrl: './store-product-card.component.html',
  styleUrls: ['./store-product-card.component.scss'],
})
export class StoreProductCardComponent {
  @Input() product: StoreProduct;
  /** Quantidade ja no carrinho; 0 significa fora do carrinho. */
  @Input() quantity = 0;
  /** Saldo da carteira menos o que ja esta no carrinho. */
  @Input() remainingBalance = 0;
  /** Enquanto a carteira nao carregou, nao bloqueia nada por saldo. */
  @Input() balanceLoaded = true;

  @Output() add = new EventEmitter<StoreProduct>();
  @Output() increment = new EventEmitter<StoreProduct>();
  @Output() decrement = new EventEmitter<StoreProduct>();

  /** Rotulo canonico da categoria; vazio quando o premio nao tem uma. */
  get categoryLabel(): string {
    return (this.product && this.product.categoryLabel) || '';
  }

  get inCart(): boolean {
    return this.quantity > 0;
  }

  get stock(): number {
    return Number(this.product && this.product.quantity) || 0;
  }

  get value(): number {
    return Number(this.product && this.product.value) || 0;
  }

  get outOfStock(): boolean {
    return this.stock <= 0;
  }

  get lowStock(): boolean {
    return this.stock > 0 && this.stock <= LOW_STOCK_THRESHOLD;
  }

  /**
   * Bloqueio por saldo vale so para quem ainda nao esta no carrinho: bloquear o
   * card inteiro impediria o usuario de DIMINUIR a quantidade e o deixaria preso.
   */
  get insufficient(): boolean {
    return this.balanceLoaded && !this.inCart && !this.outOfStock && this.value > this.remainingBalance;
  }

  get disabled(): boolean {
    return this.outOfStock || this.insufficient;
  }

  get canIncrement(): boolean {
    if (this.quantity >= this.stock) {
      return false;
    }
    return !this.balanceLoaded || this.value <= this.remainingBalance;
  }

  /** Por que o + esta travado, quando esta. Vazio quando da para aumentar. */
  get limitReason(): string {
    if (this.canIncrement || !this.inCart) {
      return '';
    }
    return this.quantity >= this.stock ? 'clicStore.stockLimit' : 'clicStore.notEnoughForOneMore';
  }

  get imageSrc(): string {
    return (this.product && this.product.image) || PRODUCT_PLACEHOLDER;
  }

  onImageError(event: Event): void {
    const img = event.target as HTMLImageElement;
    if (img && !img.src.endsWith(PRODUCT_PLACEHOLDER)) {
      img.src = PRODUCT_PLACEHOLDER;
    }
  }
}
